import type { CoverageMetricThresholdGroup } from '@flowqa/shared';

export type CoveragePanelMetricKey = 'lines' | 'functions' | 'branches' | 'statements';
export type CoverageMetricThresholdKey = keyof CoverageMetricThresholdGroup;

export type CoverageMetricConfig = {
  id: CoveragePanelMetricKey;
  thresholdKey: CoverageMetricThresholdKey;
  title: string;
};

export const coverageMetricConfigs = [
  { id: 'lines', thresholdKey: 'line', title: 'Line Coverage' },
  { id: 'functions', thresholdKey: 'function', title: 'Function Coverage' },
  { id: 'branches', thresholdKey: 'branch', title: 'Branch Coverage' },
  { id: 'statements', thresholdKey: 'statement', title: 'Statement Coverage' },
] as const satisfies readonly CoverageMetricConfig[];

const coverageMetricConfigById = new Map<CoveragePanelMetricKey, CoverageMetricConfig>(
  coverageMetricConfigs.map((config) => [config.id, config]),
);

export const getCoverageMetricConfig = (metric: CoveragePanelMetricKey): CoverageMetricConfig => {
  const config = coverageMetricConfigById.get(metric);
  if (config) return config;

  throw new Error(`Unknown coverage metric: ${metric}`);
};
